import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { useColors } from "@inbody/core";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import { Box, Stack, Typography, Tooltip, IconButton } from "@mui/material";
import { SeatFloorPlanView } from "./SeatFloorPlanView.js";
import { SeatLocationApiProvider, useSeatLocationApi } from "./SeatLocationApiContext.js";
import { formatSeatFloorLabel } from "./seatLocation.js";
import { useFetchMemberSeat, useFetchSeatFloorPlan } from "./useSeatLocation.js";
import { SectionCard } from "../section-card/SectionCard.js";
import { ModalBase } from "../modal-base/ModalBase.js";
function MemberSeatCardBody({
  memberGuid,
  memberName,
  title = "좌석 위치"
}) {
  const { gray } = useColors();
  const [expanded, setExpanded] = useState(false);
  const seatApi = useSeatLocationApi();
  const { data: seat } = useFetchMemberSeat(memberGuid);
  const { data: floor, isLoading: isFloorLoading } = useFetchSeatFloorPlan(
    seat == null ? void 0 : seat.floorId
  );
  if (!seatApi || !memberGuid || !seat) return null;
  const planUrl = (floor == null ? void 0 : floor.planUrl) ?? seat.planUrl;
  const highlight = {
    memberGuid: seat.memberGuid ?? memberGuid,
    name: memberName,
    x: seat.x,
    y: seat.y
  };
  const floorLabel = formatSeatFloorLabel(
    seat.floorName || (floor == null ? void 0 : floor.floorName),
    seat.workPlaceName || (floor == null ? void 0 : floor.workPlaceName)
  );
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      SectionCard,
      {
        title,
        titleInfo: floorLabel ? `(${floorLabel})` : void 0,
        expandable: false,
        actions: planUrl ? /* @__PURE__ */ jsx(Tooltip, { title: "크게 보기", children: /* @__PURE__ */ jsx(
          IconButton,
          {
            size: "small",
            "aria-label": "좌석 위치 크게 보기",
            onClick: () => setExpanded(true),
            sx: { color: gray[500] },
            children: /* @__PURE__ */ jsx(OpenInFullIcon, { sx: { fontSize: 16 } })
          }
        ) }) : void 0,
        children: /* @__PURE__ */ jsx(Box, { sx: { p: 1.5 }, children: /* @__PURE__ */ jsxs(Stack, { spacing: 0.75, children: [
          /* @__PURE__ */ jsx(
            SeatFloorPlanView,
            {
              planUrl,
              pins: floor == null ? void 0 : floor.pins,
              highlight
            }
          ),
          /* @__PURE__ */ jsx(Typography, { variant: "small", sx: { color: gray[500] }, children: isFloorLoading ? "같은 층 좌석을 불러오는 중입니다." : "회색 점은 같은 층의 다른 좌석입니다. 점 위에 마우스를 올리면 좌석 주인을 확인할 수 있습니다." })
        ] }) })
      }
    ),
    /* @__PURE__ */ jsx(
      ModalBase,
      {
        open: expanded,
        onClose: () => setExpanded(false),
        title: floorLabel ? `${memberName} ${title} (${floorLabel})` : `${memberName} ${title}`,
        maxWidth: "desktop",
        children: /* @__PURE__ */ jsx(
          SeatFloorPlanView,
          {
            planUrl,
            pins: floor == null ? void 0 : floor.pins,
            highlight,
            showNames: true
          }
        )
      }
    )
  ] });
}
function MemberSeatCard({ apiClient, ...props }) {
  if (!apiClient) return /* @__PURE__ */ jsx(MemberSeatCardBody, { ...props });
  return /* @__PURE__ */ jsx(SeatLocationApiProvider, { client: apiClient, children: /* @__PURE__ */ jsx(MemberSeatCardBody, { ...props }) });
}
export {
  MemberSeatCard
};
